<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 订单中心->导入订单 -->
    <div class="main2" style="padding:0;">
      <div class="df-tips" style="padding:0;">
        <div class="top">注意事项:</div>
        <div class="bottom">
          <div class="item">
            1.如果提示:"请对上传接口返回json字符"，请多上传两次到三次即可导入
          </div>
          <div class="item">
            2.请不要使用ie浏览器或者360兼容模式，建议使用谷歌或火狐或360极速模式
          </div>
          <div class="item">
            3.如果出现导入失败,例如
            屏幕闪动但是下方没有数据，请尝试清除excel内的格式后再导入
          </div>
          <div class="item">
            4.请仔细核查地址数据，例如有没有写区/县，或者越过地级市直接写县级市，或者写高新区之类民政部没有的区，如果对地址库有疑问，请点击下载全国最新地址库
          </div>
          <div class="item">
            5.商品sku中数量一定要用英文括号:();错误写法（）
          </div>
        </div>
      </div>
      <div class="main2" style="padding:0;">
        <div class="top flexStyle2" style="padding:0;">
          <div class="item">
            选择导入文件
            <input
              type="file"
              ref="referenceUpload"
              readonly="readonly"
              class="getInterOrder"
              value="导入订单"
              @change="chooseFile"
            />
          </div>
          <div class="hands item" @click="downLoadEmptyModle">
            下载空模版
          </div>
          <div class="hands item" @click="downLoadMuchGoodsModle">
            下载模版(带商品)
          </div>
          <div class="hands item" @click="getCountryAddressInfo">
            导出全国地址库
          </div>
          <div class="hands item" @click="resetInterInfo">
            重置导入信息
          </div>
          <!-- <div class="hands item c-animation"  @click="editAddress(0)">
            修改地址
          </div> -->
        </div>
        <div class="bottom">
          <el-table
            :data="currentPageInfo"
            style="width: 100%"
            :cell-style="{
              'text-align': 'center',
              'border-color': '#dbdbdb',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '300',
              'text-align': 'center',
              'padding-left': '5px',
              'padding-right': '5px',
              'border-right': '1px solid #c1c1c1',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column prop="num" align="center" label="序号" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column prop="goodsName" label="商品名称" min-width="140">
              <template slot-scope="scope">
                <span
                  :class="
                    scope.row.goodsSku.indexOf('无效SKU') != -1 ? 'error' : ''
                  "
                  v-html="scope.row.goodsName"
                ></span>
              </template>
            </el-table-column>
            <el-table-column prop="goodsSku" label="S K U" min-width="110">
              <template slot-scope="scope">
                <span
                  :class="
                    scope.row.goodsSku.indexOf('无效SKU') != -1 ? 'error' : ''
                  "
                  v-html="scope.row.goodsSku"
                ></span>
              </template>
            </el-table-column>

            <el-table-column prop="consignee" label="联系人" min-width="85">
              <template slot-scope="scope">
                <span v-if="scope.row.consignee">{{
                  scope.row.consignee
                }}</span>
                <span class="error" v-else>错误联系人</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="consigneePhone"
              label="手机/电话"
              min-width="115"
            >
              <template slot-scope="scope">
                <span v-if="checkPhone(scope.row.consigneePhone)">{{
                  scope.row.consigneePhone
                }}</span>
                <span class="error" v-else>错误联系人电话</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="isStock"
              prop="goodsStock"
              label="库存"
              min-width="70"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.goodsStock">{{
                  getShowStock(scope.row.goodsStock)
                }}</span>
                <span class="error" v-else>库存不足</span>
              </template>
            </el-table-column>

            <el-table-column
              prop="consigneeAddr"
              min-width="130"
              label="收货地址"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    scope.row.province &&
                      scope.row.city &&
                      scope.row.area &&
                      scope.row.consigneeAddr
                  "
                >
                  {{
                    scope.row.province +
                      scope.row.city +
                      scope.row.area +
                      scope.row.consigneeAddr
                  }}
                </div>
                <div class="error" v-else>
                  <el-link
                    type="primary"
                    @click="editAddress(scope.$index, scope.row)"
                    >错误收货地址</el-link
                  >
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="deliveryName" label="快递名称">
              <template slot-scope="scope">
                <div v-if="scope.row.isDelivery == 0">
                  <el-link @click="editDelivery(scope.$index, scope.row)">{{
                    scope.row.deliveryName
                  }}</el-link>
                </div>

                <div class="error" v-else>
                  <el-link
                    type="primary"
                    @click="editDelivery(scope.$index, scope.row)"
                    >错误快递</el-link
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="stockName" label="仓库名称">
              <template slot-scope="scope">
                <div v-if="scope.row.stockName != ''">
                  {{ scope.row.stockName }}
                </div>

                <div v-else>
                  默认仓库
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="90" />
          </el-table>
        </div>
        <div class="buttons flexStyle1" v-if="currentPageInfo.length > 0">
          <div class="hands item c-animation" @click="submitInterBefore">
            确认导入
          </div>
        </div>
      </div>
    </div>
    <!-- 订单中心->导入订单 -->
    <el-dialog title="地址修改" :visible.sync="editShow">
      <el-form :model="dialogForm">
        <el-form-item label="选择地区：" :label-width="formLabelWidth">
          <el-col :span="6">
            <el-form-item prop="selectProv">
              <el-select
                size="small"
                style="width: 95%"
                v-model="dialogForm.province"
                v-on:change="getProv($event)"
                filterable
                placeholder="请选择省份"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataProv"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item prop="selectCity">
              <el-select
                size="small"
                style="width: 95%"
                v-model="dialogForm.city"
                v-on:change="getCity($event)"
                filterable
                placeholder="请选择城市"
              >
                <el-option
                  :value="n.name"
                  :key="index"
                  :label="n.name"
                  v-for="(n, index) in dataCity"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="selectCountry">
              <el-select
                size="small"
                style="width:95%"
                v-model="dialogForm.area"
                v-on:change="getArea($event)"
                filterable
                placeholder="请选择区/县"
              >
                <el-option
                  :value="n"
                  :key="index"
                  :label="n"
                  v-for="(n, index) in dataArea"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="详细地址" :label-width="formLabelWidth">
          <el-input
            v-model="dialogForm.consigneeAddr"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="savePrice">确 定</el-button>
        <el-button @click="closePriceShow">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="快递修改"
      top="28vh"
      width="400px"
      :visible.sync="deliveryShow"
    >
      <el-form :model="kdForm">
        <el-form-item label="快递名称" :label-width="formLabelWidth">
          <el-select
            v-model="kdForm.deliveryId"
            size="small"
            placeholder="请选择快递名称"
          >
            <el-option
              v-for="(item2, index2) in kdList2"
              :key="index2"
              :label="item2.deliveryName"
              :value="item2.deliveryId"
              :disabled="item2.isWeb == '0' && item2.status == '1'"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveDelivery">确 定</el-button>
        <el-button @click="closeDelivery">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getUrl,
  cityRequest,
  exportReequest,
  upLoadOrderRequest,
  orderInsertsRequest,
  kdListRequest,
  batchFileRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      fileUrl: null,
      currentPageInfo: [], // 1.1.currentPageInfo
      token: "", // 1.2.token
      formLabelWidth: "120px",
      isStock: true,
      editShow: false,
      editIndex: 0,
      citys_path: "", // 1.9.地址的请求路径
      country: [], // 1.10.全国数据
      dataProv: [],
      dataCity: [],
      dataArea: [],
      dialogForm: {
        province: "",
        city: "",
        area: "",
        consigneeAddr: "",
      },
      deliveryShow: false,
      deliveryId: null,
      kdList: [],
      kdList2: [],
      kdForm: {
        deliveryId: null,
        deliveryName: null,
      },
      fileTypes: {
        // 1.3.可上传文件类型
        accept:
          "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    };
  },

  components: {
    // 2.components
  },

  methods: {
    getShowStock(v) {
      if (v >= 9999) {
        return "有货";
      }
      return v;
    },
    // 3.methods
    getCountryAddressInfo() {
      // 3.1.都出全国地质库
      exportReequest("api/download/address/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "全国地址库.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    getKDInfo() {
      // 3.3.获取快递信息
      kdListRequest().then((res) => {
        if (res) {
          this.kdList = res.data;
        }
      });
    },

    downLoadEmptyModle() {
      // 3.2.下载空模版
      exportReequest("api/download/goodslist/empty/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "无商品模版.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    chooseFile(event) {
      // 3.3.上传文件
      setTimeout(() => {
        let targetFile = event.target.files[0];
        let tff = targetFile.type;
        if (tff == "") {
          let extName = targetFile.name
            .substring(targetFile.name.lastIndexOf("."))
            .toLowerCase();
          let AllUpExt = ".xls|.xlsx|";
          if (AllUpExt.indexOf(extName + "|") == "-1") {
            this.$message.error("请选择正确格式文件！");
            this.$refs.referenceUpload.value = null;
            return false;
          }
        } else {
          if (this.fileTypes.accept.indexOf(targetFile.type) == -1) {
            this.$message.error("请选择正确格式文件！");
            this.$refs.referenceUpload.value = null;
            return false;
          }
        }

        let formData = new FormData();
        formData.append("file", targetFile, targetFile.name);

        this.openLoading();

        upLoadOrderRequest(formData).then((res) => {
          if (res) {
            this.fileUrl = res.url;
            if (!this.isStock) {
              this.currentPageInfo = res.data.map((item) => {
                delete item.status;
                delete item.params;
                item.isDelivery = 0;
                return item;
              });
            } else {
              let ary = [];
              for (let j = 0; j < res.data.length; j++) {
                let row = res.data[j];
                if (row.listGoodTemp) {
                  for (var k = 0; k < row.listGoodTemp.length; k++) {
                    let item = row.listGoodTemp[k];
                    let ss = {};
                    ss.consignee = row.consignee;
                    ss.consigneePhone = row.consigneePhone;
                    ss.province = row.province;
                    ss.city = row.city;
                    ss.area = row.area;
                    ss.consigneeAddr = row.consigneeAddr;
                    ss.goodsName = item.goodsName + "(" + item.goodsCount + ")";
                    ss.goodsSku = item.goodsCode + "(" + item.goodsCount + ")";
                    ss.goodsStock = item.goodsStock || 0;
                    ss.remark = row.remark;
                    if ((row.errCode || "").indexOf("快递名称错误，") == -1) {
                      ss.deliveryId = row.deliveryId || 1;
                      ss.deliveryName = row.deliveryName || "京东快递";
                    } else {
                      ss.deliveryId = row.deliveryId;
                      ss.deliveryName = row.deliveryName;
                    }
                    ss.isDelivery = 1;
                    ss.stockName = row.stockName;
                    let kdAry = [];
                    for (let p = 0; p < this.kdList.length; p++) {
                      let dd = this.kdList[p];
                      if (dd.deliveryId == ss.deliveryId) {
                        if (dd.status == "0" && dd.isWeb == "0") {
                          ss.isDelivery = 0;
                          break;
                        }
                      }
                    }
                    for (let p = 0; p < this.kdList.length; p++) {
                      let dd = this.kdList[p];
                      if (row.isSupplier == "0") {
                        if (row.isEditDelivery == "1") {
                          if ((dd.isWebPlat || "0") == "0") {
                            kdAry.push(dd);
                          }
                        } else {
                          if (dd.deliveryId == ss.deliveryId) {
                            kdAry.push(dd);
                          }
                        }
                      }
                      if (row.isSupplier == "1") {
                        if ((dd.isWebSupplier || "0") == "0") {
                          kdAry.push(dd);
                        }
                      }
                    }
                    ss.kdAry = kdAry;
                    ary.push(ss);
                  }
                }
              }
              this.currentPageInfo = ary;
            }
            this.$refs.referenceUpload.value = null;
            this.closeLoading();
          } else {
            this.$refs.referenceUpload.value = null;
            this.closeLoading();
          }
        });
      }, 500);
    },

    submitInterBefore() {
      // 3.4.确认导入之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导入?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            if (_this.currentPageInfo.length <= 0) {
              _this.$notify({
                title: "提示",
                message: "请选择文件后确认",
              });
            } else {
              _this.sumitInterTwoStep();
            }
          }
        },
      });
    },

    sumitInterTwoStep() {
      // 3.5.确认导入之前第二步，验证用户是否为正确导入
      let msg = "";
      let jj = 0;
      let result = this.currentPageInfo.some((item) => {
        jj++;
        let res = Object.keys(item).some((key) => {
          if (
            key == "area" ||
            key == "remark" ||
            key == "errCode" ||
            key == "deliveryId" ||
            key == "stockName" ||
            key == "kdAry"
          ) {
            return false;
          }
          if (key == "goodsSku") {
            if (item[key].indexOf("无效SKU") != -1) {
              msg = "第" + jj + "行，商品无效SKU错误！";
              return true;
            }
          }

          if (key == "consignee") {
            if (item[key] == "") {
              msg = "第" + jj + "行，联系人不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "province") {
            if (item[key] == "") {
              msg = "第" + jj + "行，地址省份不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "city") {
            if (item[key] == "") {
              msg = "第" + jj + "行，地址城市不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "consigneeAddr") {
            if (item[key] == "") {
              msg = "第" + jj + "行，详细地址不能为空！";
              return true;
            } else {
              return false;
            }
          }

          if (key == "isDelivery") {
            if (item[key] == 1) {
              msg = "第" + jj + "行，快递错误！";
              return true;
            } else {
              return false;
            }
          }
          if (!item[key]) {
            console.log(key + ">>>>" + item[key]);
            msg = "第" + jj + "行，数据有误！";
            return true;
          }
        });
        return res;
      });

      if (!result) {
        this.submitInter();
      } else {
        this.$message.error(
          msg == ""
            ? "当前导入订单中存在错误信息，请按照标准核实后重新导入。"
            : msg
        );
      }
    },

    submitInter() {
      // 3.6.确认导入
      let data = this.currentPageInfo.map((item) => {
        delete item.goodsCount;
        return item;
      });

      this.openLoading();

      orderInsertsRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          if (res.code != 500) {
            let obj = {
              batchId: res.batchId,
              batchName: res.batchName,
              status: 1,
            };

            batchFileRequest({
              batchId: res.batchId,
              batchFile: this.fileUrl,
            });

            this.currentPageInfo = [];
            this.$router.push(
              "/interOrderDetail?obj=" + encodeURIComponent(JSON.stringify(obj))
            );
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        }
      });
    },

    downLoadMuchGoodsModle() {
      // 3.7.下载多商品模版
      exportReequest("api/download/goodslist/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "多商品模版.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    resetInterInfo() {
      // 3.8.重置导入信息
      this.currentPageInfo = [];
      this.$emit("reset", 0);
    },

    openLoading() {
      // 3.9.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.10.关闭遮罩层
      this.loadingInstance.close();
    },
    editDelivery(index) {
      this.deliveryShow = true;
      this.kdList2 = this.currentPageInfo[index].kdAry || [];
      this.editIndex = index;
    },
    closeDelivery() {
      // 3.10.关闭开票遮罩层
      this.deliveryShow = false;
    },
    saveDelivery() {
      if (this.currentPageInfo.length > this.editIndex) {
        this.currentPageInfo[
          this.editIndex
        ].deliveryId = this.kdForm.deliveryId;

        for (let j = 0; j < this.kdList.length; j++) {
          if (this.kdList[j].deliveryId == this.kdForm.deliveryId) {
            this.kdForm.deliveryName = this.kdList[j].deliveryName;
            if (this.kdList[j].status == "0") {
              this.currentPageInfo[this.editIndex].isDelivery = 0;
            }
            break;
          }
        }
        this.currentPageInfo[
          this.editIndex
        ].deliveryName = this.kdForm.deliveryName;
      }
      this.deliveryShow = false;
      console.log(this.kdForm);
    },

    editAddress(index) {
      this.editShow = true;
      this.editIndex = index;
      if (this.currentPageInfo.length > this.editIndex) {
        this.dialogForm.consigneeAddr = this.currentPageInfo[
          index
        ].consigneeAddr;
        this.dialogForm.province = this.currentPageInfo[index].province;
        this.dialogForm.city = this.currentPageInfo[index].city;
        this.dialogForm.area = this.currentPageInfo[index].area;
      }
      this.initAddress(this.dialogForm);
    },

    closePriceShow() {
      // 3.10.关闭开票遮罩层
      this.editShow = false;
    },
    savePrice() {
      if (this.currentPageInfo.length > this.editIndex) {
        this.currentPageInfo[
          this.editIndex
        ].province = this.dialogForm.province;
        this.currentPageInfo[this.editIndex].city = this.dialogForm.city;
        this.currentPageInfo[this.editIndex].area = this.dialogForm.area;
        this.currentPageInfo[
          this.editIndex
        ].consigneeAddr = this.dialogForm.consigneeAddr;
      }
      this.editShow = false;
      console.log(this.dialogForm);
    },
    initAddress(vv) {
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv.province) {
          this.dataCity = this.dataProv[j].cityList;
          break;
        }
      }
      for (let k = 0; k < this.dataCity.length; k++) {
        if (this.dataCity[k].name == vv.city) {
          this.dataArea = this.dataCity[k].areaList;
          break;
        }
      }
    },
    getProv: function(vv) {
      let index = 0;
      console.log(index);
      for (let j = 0; j < this.dataProv.length; j++) {
        if (this.dataProv[j].name == vv) {
          index = j;
          break;
        }
      }
      this.dataCity = this.dataProv[index].cityList;
      if (this.dataArea.length > 0) {
        this.dialogForm.city = this.dataCity[0].name;
      } else {
        this.dialogForm.city = "";
      }
    },
    getCity: function(vv) {
      let index = 0;
      for (let j = 0; j < this.dataCity.length; j++) {
        if (this.dataCity[j].name == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      this.dataArea = this.dataCity[index].areaList;
      if (this.dataArea.length > 0) {
        this.dialogForm.area = this.dataArea[0];
      } else {
        this.dialogForm.area = "";
      }
    },
    getArea: function(vv) {
      let index = 0;
      for (let j = 0; j < this.dataArea.length; j++) {
        if (this.dataArea[j] == vv) {
          index = j;
          break;
        }
      }
      console.log(index);
      //this.form.counties = this.dataArea[index];
    },
    getCityJson() {
      cityRequest(1).then((res) => {
        if (res) {
          this.dataProv = res;
          this.getProv(0);
        }
      });
    },
    SelectionChange() {},
    checkPhone(vv) {
      let xx = true;
      if (vv.trim().length != 11) {
        // 校验收货电话
        if (vv.trim().indexOf("-") == -1) {
          xx = false;
        }
      }
      return xx;
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getKDInfo();
    }
    this.getCityJson();
  },
};
</script>
